import * as React from 'react';

const ToolBar: React.FC<{ className?: string; sticky?: boolean }> = ({
  children,
  className,
  sticky
}: any) => (
  <div
    className={`${
      sticky ? 'sticky' : ''
    } click-through flex-none flex items-center mb3 mb0-l pt3 pb2 pv3-l f6 w-100 z-999 ${className}`}
    style={{
      backgroundColor: 'rgba(255,255,255,.85)'
    }}
  >
    {children}
  </div>
);

export default ToolBar;
